import React, { Component } from "react";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import { Icon } from "semantic-ui-react";
import Select, { components } from "react-select";
import CustomDropdown from "../Charts/ChartsOptionsSidebar/CustomDropdown";

const IndicatorsContainer = ({ children, ...props }) => {
    return (
        <components.IndicatorsContainer {...props}>
            <div className="react-select-control">
                {children}
                {/* <p>hello</p> */}
                <Icon
                    name={"caret down"}
                    style={{
                        marginTop: 3,
                    }}
                />
            </div>
        </components.IndicatorsContainer>
    );
};

// const customStyles = {
//     valueContainer: (provided) => ({
//         ...provided,
//         maxWidth: "90%",
//         display: "initial",
//         fontSize: 12,
//     }),
//     control: (base) => ({
//         ...base,
//         border: "1px solid #d3d8de",
//         minHeight: 30,
//         backgroundColor: "#eff1f5",
//         // This line disable the blue border
//         boxShadow: "none",
//     }),
// };

const customStyles = {
    control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#F5F6FA", height: "36px", minHeight: "36px" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return { ...styles, backgroundColor: isFocused ? "#F5F6FA" : null, color: "#1f2e3d", opacity: isDisabled ? 0.5 : 1 };
    },
    dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && "rotate(180deg) translateY(5px)",
    }),

    menuList: (base) => ({
        ...base,
        padding: "7px",
        margin: "4px",
        fontSize: 14,

        "::-webkit-scrollbar": {
            width: "2px",
        },
        "::-webkit-scrollbar-track": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "white",
        },
    }),
};
class SentimentSelector extends Component {
    state = {};

    render() {
        let all_disabled = false;
        let positive_disabled = false;
        let negative_disabled = false;
        let neutral_disabled = false;
        let topLevelSentiment = this.props.appliedFilter?.refineOptions?.sentiment || [];

        if (!topLevelSentiment.includes("positive")) {
            positive_disabled = true;
        }
        if (!topLevelSentiment.includes("negative")) {
            negative_disabled = true;
        }
        if (!topLevelSentiment.includes("neutral")) {
            neutral_disabled = true;
        }
        if (topLevelSentiment.includes("all")) {
            negative_disabled = false;
            positive_disabled = false;
            neutral_disabled = false;
        }

        const aggsIntervalOptions = [
            { key: "default", label: "All", value: "All", disabled: all_disabled },
            { key: "Positive", label: "Positive", value: "positive", disabled: positive_disabled },
            { key: "Negative", label: "Negative", value: "negative", disabled: negative_disabled },
            { key: "Neutral", label: "Neutral", value: "neutral", disabled: neutral_disabled },
        ];
        let obj =
            this.props.appliedFilter && this.props.appliedFilter.sentiment
                ? aggsIntervalOptions.find((o) => o.value === this.props.appliedFilter.sentiment).value
                : "All";

        return (
            <CustomDropdown
                className="interval-selector"
                name="Sentiment"
                onChange={this.props.handleSentimentChange}
                value={obj}
                options={aggsIntervalOptions}
            />
        );
    }
}

export default SentimentSelector;
